import { useTranslation } from "react-i18next";
import {
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  BarChart,
  YAxis,
  Tooltip,
  Bar,
} from "recharts";

interface StatsChartProps {
  yearlyRevenue: { month: string; amount: number }[];
}

export const StatsChart = ({ yearlyRevenue }: StatsChartProps) => {
  const { t } = useTranslation();
  return (
    <div className="p-6 bg-popupLight dark:bg-popupDark dark:text-primaryTextDark text-primaryText rounded-xl shadow mt-6">
      <h2 className="text-xl font-semibold mb-4">{t("Last Year Revenue")}</h2>

      <div className="w-full h-64 focus:outline-none focus:ring-0">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={yearlyRevenue}>
            <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.2} />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip
              cursor={{ fill: "transparent" }}
              contentStyle={{
                backgroundColor: "var(--chart-bar)",
                border: "none",
                borderRadius: "15px",
              }}
            />
            <Bar
              dataKey="amount"
              fill="var(--bar-fill)"
              radius={[6, 6, 0, 0]}
              activeBar={false}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <style>{`
        :root {
          --bar-fill: #dadeee;
        }
        .dark {
          --bar-fill: #111827;
        }
      `}</style>
    </div>
  );
};
